/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SiteSectionDocumentFromJSON, SiteSectionDocumentToJSON } from './SiteSectionDocument';
export function CreateSiteSectionDocumentResponseDataFromJSON(json) {
    return CreateSiteSectionDocumentResponseDataFromJSONTyped(json, false);
}
export function CreateSiteSectionDocumentResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        siteSectionDocument: !exists(json, 'site_section_document')
            ? undefined
            : SiteSectionDocumentFromJSON(json['site_section_document'])
    };
}
export function CreateSiteSectionDocumentResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        site_section_document: SiteSectionDocumentToJSON(value.siteSectionDocument)
    };
}
